module.exports = __webpack_public_path__ + "static/media/machine_line_management.d994adee.svg";